<script setup>
import {useMutation, useQueryClient} from "@tanstack/vue-query";
import axios from "axios";
import SquareIconButton from "@/components/global-themed/buttons/SquareIconButton.vue";
import {errorToast, successToast} from "@/composables/useToasts";

defineProps({
  pageId: {
    type: Number,
    required: true,
  },
})

const queryClient = useQueryClient();

const {mutate: completeActions} = useMutation({
  mutationFn: async (pageId) => await axios.post(`/ajax/v2/actions/page/${pageId}/complete`),
  onSuccess: () => {
    successToast('Actions marked as complete');
    queryClient.invalidateQueries(['actions']);
  },
  onError: (error) => {
    const {message} = error.response.data
    errorToast(message ?? 'Something went wrong completing actions');
  },
});
</script>

<template>
  <SquareIconButton
    v-tooltip="{
      content: 'Complete all actions on this page',
      theme: 'dark-blue-tooltip',
      placement: 'bottom',
    }"
    variant="primary-inverted"
    size="small"
    @click="() => completeActions(pageId)"
  >
    <svg-vue
      icon="icons/tick-thin"
      class="tw-h-6 tw-w-6"
    />
  </SquareIconButton>
</template>
